import { TooltipConfig } from "ngx-bootstrap/tooltip";

export function getTooltipDefaultConfig(): TooltipConfig {
    return Object.assign(new TooltipConfig(), {
        container: 'body',
    });
}